import React, { useRef, useState } from "react";

export function useSpamGuard() {
  const startedAt = useRef(Date.now());
  const [website, setWebsite] = useState("");
  const fields = () => ({ website, elapsedMs: Date.now() - startedAt.current });
  const reset = () => { startedAt.current = Date.now(); setWebsite(""); };
  const Honeypot = (
    <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: 1, height: 1, overflow: "hidden" }}>
      <label>Website<input type="text" name="website" tabIndex={-1} autoComplete="off" value={website}
        onChange={(e) => setWebsite(e.target.value)} data-testid="hp-website" /></label>
    </div>
  );
  return { fields, reset, Honeypot };
}
